import {
  AutocompleteFilter,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@shigo-ui/ui';

import { dashboardT } from '../../../../lib/messages';
import { reportMetricLabel } from '../../reportExplorer/format';
import type { ReportMetric } from '../../reportExplorer/reportEnums';
import type { PerformanceEntityOption } from '../model';

export function MetricControl({
  metrics,
  selected,
  onChange,
}: {
  metrics: readonly ReportMetric[];
  selected: ReportMetric[];
  onChange: (metrics: ReportMetric[]) => void;
}) {
  return (
    <div className="w-full sm:w-64">
      <AutocompleteFilter
        label={dashboardT('performanceAnalyzer.selectMetrics')}
        searchPlaceholder={dashboardT('performanceAnalyzer.searchMetrics')}
        options={metrics.map((metric) => ({ id: metric, label: reportMetricLabel(metric) }))}
        selectedIds={selected}
        onSelectedIdsChange={(ids) => {
          onChange(ids as ReportMetric[]);
        }}
      />
    </div>
  );
}

export function EntityControl({
  label,
  options,
  value,
  onChange,
}: {
  label: string;
  options: readonly PerformanceEntityOption[];
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <Select value={value} onValueChange={onChange} disabled={options.length === 0}>
      <SelectTrigger className="w-full sm:w-64" aria-label={label}>
        <SelectValue placeholder={label} />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.id} value={option.id}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
